import { render, staticRenderFns } from "./HostingKvmDocker.vue?vue&type=template&id=35344c5e&scoped=true&"
import script from "./HostingKvmDocker.vue?vue&type=script&lang=js&"
export * from "./HostingKvmDocker.vue?vue&type=script&lang=js&"
import style0 from "./HostingKvmDocker.vue?vue&type=style&index=0&id=35344c5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35344c5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35344c5e')) {
      api.createRecord('35344c5e', component.options)
    } else {
      api.reload('35344c5e', component.options)
    }
    module.hot.accept("./HostingKvmDocker.vue?vue&type=template&id=35344c5e&scoped=true&", function () {
      api.rerender('35344c5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/kvm/HostingKvmDocker.vue"
export default component.exports